export default __webpack_public_path__ + "static/media/sticker-y.4f808ba9.png";